// extracted by mini-css-extract-plugin
export default {"infoIcon":"PromocodeButton-module__infoIcon--gKkIp"};